import { render, staticRenderFns } from "./FaqAdmin.vue?vue&type=template&id=62709036&scoped=true"
import script from "./FaqAdmin.vue?vue&type=script&lang=js"
export * from "./FaqAdmin.vue?vue&type=script&lang=js"
import style0 from "./FaqAdmin.vue?vue&type=style&index=0&id=62709036&prod&lang=css"
import style1 from "./FaqAdmin.vue?vue&type=style&index=1&id=62709036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62709036",
  null
  
)

export default component.exports